// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 418) return "static/chunks/418-e227d631481ce310.js";
	if (chunkId === 999) return "static/chunks/999-de7c72f628d51c33.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"3e28d618dfa0b01a","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"314a6b8dd9f0f45c","367":"2ed850fd95b00f4e","639":"3dbd0979adbf295f","748":"8731670a251641dd"}[chunkId] + ".js";
};